import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import LinkedInCallback from './pages/LinkedInCallback';
import Dashboard from './pages/ConversationsAnalytics';
import ChartsShowcase from './pages/ChartsShowcase';
import VisxShowcase from './pages/VisxShowcase';
import GoogleChartsShowcase from './pages/GoogleChartsShowcase';
import EChartsShowcase from './pages/EChartsShowcase';
import GanttShowcase from './pages/GanttShowcase';
import FunnelShowcase from './pages/FunnelShowcase';
import LiveClassDashboard from './pages/academic/LiveClassDashboard';
import ClassAnalytics from './pages/academic/ClassAnalytics';
import TranscriptAnalysis from './pages/academic/TranscriptAnalysis';
import NPSCustomerExperience from './pages/academic/NPSCustomerExperience';
import AcademicOverview from './pages/academic/AcademicOverview';
import ConversationDetailNew from './pages/ConversationDetailNew';
import ConversationsWrapper from './pages/ConversationsWrapper';
import Search from './pages/Search';
import LayoutNew from './components/LayoutNew';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ConversationRefreshProvider } from './contexts/ConversationRefreshContext';
import ProtectedRoute from './components/ProtectedRoute';
import SessionExpiredDialog from './components/SessionExpiredDialog';

function AppContent() {
  const { sessionExpired, sessionExpiredReason, handleSessionExpiredClose } = useAuth();
  
  return (
    <>
      <SessionExpiredDialog 
        open={sessionExpired} 
        onClose={handleSessionExpiredClose}
        reason={sessionExpiredReason}
      />
      <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/linkedin" element={<LinkedInCallback />} />
          <Route path="/" element={
            <ProtectedRoute>
              <LayoutNew />
            </ProtectedRoute>
          }>
                      <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="charts-showcase" element={<ChartsShowcase />} />
          <Route path="visx-showcase" element={<VisxShowcase />} />
          <Route path="google-charts-showcase" element={<GoogleChartsShowcase />} />
          <Route path="echarts-showcase" element={<EChartsShowcase />} />
          <Route path="gantt-showcase" element={<GanttShowcase />} />
          <Route path="funnel-showcase" element={<FunnelShowcase />} />
          <Route path="academic/live" element={<LiveClassDashboard />} />
          <Route path="academic/class-analytics" element={<ClassAnalytics />} />
          <Route path="academic/transcript" element={<TranscriptAnalysis />} />
          <Route path="academic/nps" element={<NPSCustomerExperience />} />
          <Route path="academic/overview" element={<AcademicOverview />} />
          <Route path="conversations" element={<ConversationsWrapper />}>
            <Route index element={<ConversationDetailNew />} />
            <Route path=":sessionId" element={<ConversationDetailNew />} />
          </Route>
          <Route path="search" element={<Search />} />
          </Route>
        </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <ConversationRefreshProvider>
        <AppContent />
      </ConversationRefreshProvider>
    </AuthProvider>
  );
}

export default App;